/* eslint-disable */
import sts from './sts';
import type { EnvironmentConfig } from 'models/environmentConfig';
import type { RuntimeEnv } from 'models/runtimeEnv';
import { buildEnvConfig } from 'utils/runtimeEnv';

const runtimeEnv = (window as any)._env_ as RuntimeEnv;
const env: EnvironmentConfig = buildEnvConfig(runtimeEnv, sts);

export default env;
